module.exports = __webpack_public_path__ + "static/media/icon-light.18f69d1d.svg";